/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { memo, useEffect, useMemo, useState } from 'react';
import useCurrency from 'hooks/useCurrency';
import REPAIR_TYPE from 'shared/repairTypeList';
import CURRENCY_TYPE from 'shared/currencyTypeList';
import { formatMultiplies, formatSingle } from 'utils/formatOddDecimal';
import OldDesign from './OldDesign';
import NewDesign from './NewDesign';

const CalculationByHomeData = ({
  homeData = {},
  homesData = [],
  order = 0,
  setData = () => {},
  formik,
  applyDiscount,
  setApplyDiscount,
  selectedDiscount,
  setSelectedDiscount,
  designType = 'old',
  currency,
  filters,
  setFilters,
  isCreditTable,
  isSubsidy,
}) => {
  const [fullPrice, setFullPrice] = useState(0);
  const [isrepaired, setIsrepaired] = useState(homeData?.isrepaired);
  const [sellPrice, setSellPrice] = useState(0);
  const [startPrice, setStartPrice] = useState(0);
  const [lastPayment, setLastPayment] = useState(0);
  const [startPriceTopOrder, setStartPriceTopOrder] = useState(false);
  const [startPricePercentage, setStartPricePercentage] = useState(
    homeData?.start,
  );
  const [lastPaymentPercentage, setLastPaymentPercentage] = useState(0);

  const [priceForSquare, setPriceForSquare] = useState(
    homeData?.isrepaired == REPAIR_TYPE.REPAIRED.code
      ? homeData?.repaired
      : homeData?.norepaired,
  );
  const [terassaPriceForSquare, setTerassaPriceForSquare] = useState(
    homeData?.isrepaired == REPAIR_TYPE.REPAIRED.code
      ? Number(homeData?.terassa_price_repaired)
      : Number(homeData?.terassa_price),
  );
  const square = homeData.square;
  const [discount, setDiscount] = useState(0);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [percent, setPercent] = useState(17);
  const [isEnableCalc, setIsEnableCalc] = useState(false);
  const [month, setMonth] = useState(29);
  const [priceForMonth, setPriceForMonth] = useState(0);
  // const [currency, setCurrency] = useState(
  //   homeData?.isvalute || CURRENCY_TYPE.SUM.code
  // );

  const { currencyData } = useCurrency();
  // Ikkilamchi kredit stavkasi — standart holatda sozlamalardagi qiymatni
  // oladi, lekin admin shu yerda ham (birlamchi foiz kabi) o'zgartirib qo'ya oladi
  const [secondaryPercentOverride, setSecondaryPercentOverride] =
    useState(null);
  const secondaryPercent =
    secondaryPercentOverride ?? (Number(currencyData?.secondary_rate) || 0);
  // Kredit muddati (oy) — avval 240 ga qattiq yozilgan edi, endi admin
  // o'zgartira oladi
  const [creditMonths, setCreditMonths] = useState(240);

  // Uy valyutasidagi (xom) narxni hozir tanlangan valyutaga o'tkazadi.
  // Uy so'mda, ko'rsatish $ da bo'lsa — bo'linadi; aksincha — ko'paytiriladi.
  const toCurrentCurrency = (raw) => {
    const n = Number(raw) || 0;
    if (!n || !currencyData?.sum) return n;
    if (
      homeData?.isvalute == CURRENCY_TYPE.SUM.code &&
      currency == CURRENCY_TYPE.VALUTE.code
    ) {
      return n / currencyData.sum;
    }
    if (
      homeData?.isvalute == CURRENCY_TYPE.VALUTE.code &&
      currency == CURRENCY_TYPE.SUM.code
    ) {
      return n * currencyData.sum;
    }
    return n;
  };

  // Terassa 1 m² narxi — joriy valyutada (ta'mir holatiga qarab)
  const terassaUnitPrice = () =>
    toCurrentCurrency(
      isrepaired == REPAIR_TYPE.REPAIRED.code
        ? homeData?.terassa_price_repaired
        : homeData?.terassa_price,
    );

  const handleChangeMonth = (value) => {
    setMonth(parseInt(value));
    setPriceForMonth(formatSingle((sellPrice - startPrice) / parseInt(value)));
  };

  const handleChangeStartPrice = (value) => {
    setStartPrice(value);
    setStartPricePercentage(
      sellPrice
        ? formatSingle(
            (value * 100) / (startPriceTopOrder ? fullPrice : sellPrice),
            3,
          )
        : 0,
    );
    setPriceForMonth(
      formatSingle(
        ((startPriceTopOrder ? fullPrice : sellPrice) - value) / month,
      ),
    );
  };

  const handleChangeStartPricePercent = (value) => {
    const startPrice =
      ((startPriceTopOrder ? fullPrice : sellPrice) * value) / 100;
    setStartPrice(startPrice);
    setStartPricePercentage(value);
    setPriceForMonth(formatSingle((sellPrice - startPrice) / month));
  };

  const handleChangeStartPriceOrder = (value) => {
    const startPrice =
      value && startPricePercentage < 100
        ? (startPricePercentage * fullPrice) / 100
        : (startPricePercentage * sellPrice) / 100;

    setStartPrice(startPrice);
    setPriceForMonth(formatSingle((sellPrice - startPrice) / month) || 0);
    setStartPriceTopOrder(value);
  };

  useEffect(() => {
    if (currencyData && currencyData.sum) {
      if (currency == CURRENCY_TYPE.VALUTE.code) {
        setFullPrice(fullPrice / currencyData.sum);
        setSellPrice(sellPrice / currencyData.sum);
        setDiscount(discount / currencyData.sum);
        setStartPrice(startPrice / currencyData.sum);
        setPriceForMonth(priceForMonth / currencyData.sum);
        setLastPayment(lastPayment / currencyData.sum);
        setPriceForSquare(priceForSquare / currencyData.sum);
        setTerassaPriceForSquare(terassaPriceForSquare / currencyData.sum);
      } else {
        setFullPrice(fullPrice * currencyData.sum);
        setSellPrice(sellPrice * currencyData.sum);
        setDiscount(discount * currencyData.sum);
        setStartPrice(startPrice * currencyData.sum);
        setPriceForMonth(priceForMonth * currencyData.sum);
        setLastPayment(lastPayment * currencyData.sum);
        setPriceForSquare(priceForSquare * currencyData.sum);
        setTerassaPriceForSquare(terassaPriceForSquare * currencyData.sum);
      }
    }
  }, [currency, currencyData.sum]);

  const handleChangeSellPrice = (newSellPrice) => {
    if (newSellPrice <= fullPrice) {
      const discount = fullPrice - newSellPrice;
      setDiscount(discount);
      setDiscountPercentage(
        fullPrice ? formatSingle((discount * 100) / fullPrice, 2) : 0,
      );
      setSellPrice(newSellPrice);
      setPriceForMonth(formatSingle((newSellPrice - startPrice) / month));
      let newSellP = newSellPrice;
      if (
        Number(homeData?.terassa) &&
        (Number(homeData?.terassa_price) ||
          Number(homeData?.terassa_price_repaired))
      ) {
        const terassaPrice = terassaUnitPrice();
        newSellP -= formatMultiplies([terassaPrice, homeData?.terassa], 2);
      }
      setPriceForSquare(formatSingle(newSellP / square));
    }
  };

  const handleChangeDiscount = (disc) => {
    const newDisc = disc || 0;
    if (newDisc <= fullPrice) {
      const newStartPrice =
        (startPricePercentage *
          (fullPrice - (startPriceTopOrder ? 0 : newDisc))) /
        100;
      if (startPricePercentage) {
        setStartPrice(newStartPrice);
      }
      setDiscount(newDisc);
      setDiscountPercentage(
        fullPrice ? formatSingle((newDisc * 100) / fullPrice, 2) : 0,
      );
      setSellPrice(() => fullPrice - newDisc);
      if (month == 0) {
        setPriceForMonth(0);
      } else
        setPriceForMonth(
          formatSingle((fullPrice - newDisc - newStartPrice) / month),
        );
      let newSellP = fullPrice;
      if (
        Number(homeData?.terassa) &&
        (Number(homeData?.terassa_price) ||
          Number(homeData?.terassa_price_repaired))
      ) {
        const terassaPrice = terassaUnitPrice();
        newSellP -= formatMultiplies([terassaPrice, homeData?.terassa], 2);
      }
      setPriceForSquare(formatSingle((newSellP - newDisc) / square));
    }
  };

  const handleChangeDiscountPercentage = (per) => {
    const newPer = per / 100 || 0;
    if (newPer * fullPrice <= fullPrice) {
      const newStartPrice =
        (fullPrice *
          startPricePercentage *
          (1 - (startPriceTopOrder ? 0 : newPer))) /
        100;
      if (startPricePercentage) {
        setStartPrice(newStartPrice);
      }
      setDiscount(newPer * fullPrice);
      setDiscountPercentage(per);
      setSellPrice(() => fullPrice * (1 - newPer));
      if (month == 0) {
        setPriceForMonth(0);
      } else
        setPriceForMonth(
          formatSingle(
            (fullPrice - newPer * fullPrice - newStartPrice) / month,
          ),
        );
      let newSellP = fullPrice;
      if (
        Number(homeData?.terassa) &&
        (Number(homeData?.terassa_price) ||
          Number(homeData?.terassa_price_repaired))
      ) {
        const terassaPrice = terassaUnitPrice();
        newSellP -= formatMultiplies([terassaPrice, homeData?.terassa], 2);
      }
      setPriceForSquare(formatSingle((newSellP - newPer * fullPrice) / square));
    }
  };

  const handleChangePriceSquare = (newPriceForSquare) => {
    const currPriceByRepaired =
      isrepaired == REPAIR_TYPE.REPAIRED.code
        ? parseFloat(homeData?.repaired)
        : parseFloat(homeData?.norepaired);

    const maxPrice =
      homeData?.isvalute == CURRENCY_TYPE.SUM.code &&
      currency == CURRENCY_TYPE.VALUTE.code
        ? currPriceByRepaired / currencyData.sum
        : homeData?.isvalute == CURRENCY_TYPE.VALUTE.code &&
            currency == CURRENCY_TYPE.SUM.code
          ? currPriceByRepaired * currencyData.sum
          : currPriceByRepaired;

    if (newPriceForSquare <= maxPrice) {
      let newSellP = formatMultiplies([newPriceForSquare, homeData?.square], 2);
      if (
        Number(homeData?.terassa) &&
        (Number(homeData?.terassa_price) ||
          Number(homeData?.terassa_price_repaired))
      ) {
        const terassaPrice = terassaUnitPrice();
        newSellP += formatMultiplies([terassaPrice, homeData?.terassa], 2);
      }

      // Chegirma — qoldiq sifatida (umumiy narx - sotuv narxi).
      //
      // Oldin u formatMultiplies([maxPrice - newPriceForSquare, square], 2)
      // bilan hisoblanardi. formatMultiplies ko'paytirishdan OLDIN har bir
      // ko'paytuvchini 2 xonagacha yaxlitlaydi: $ rejimida 1 m² farqi
      // 218.4873949... -> 218.49 bo'lib ketardi. Shu 0.0026 $ kursga
      // ko'paytirilganda 1 m² da 31 so'm xato berardi va UZS'ga qaytilganda
      // 23 800 000 o'rniga 23 799 969 chiqardi.
      //
      // Endi sotuv narxi foydalanuvchi kiritgan qiymatdan aynan hosil bo'ladi,
      // chegirma esa qolganini o'ziga oladi — yaxlitlash xatosi yo'qoladi.
      const newDiscount = fullPrice - newSellP;

      setDiscount(newDiscount);
      setDiscountPercentage(
        fullPrice ? formatSingle((newDiscount * 100) / fullPrice, 2) : 0,
      );
      setSellPrice(newSellP);
      setPriceForMonth(
        formatSingle((startPriceTopOrder ? fullPrice : newSellP) - startPrice) /
          month,
        2,
      );
      setPriceForSquare(newPriceForSquare);
    }
  };

  const handleChangeTerassaPriceSquare = (newPriceForSquare) => {
    // for future use if needed
  };

  useEffect(() => {
    if (!applyDiscount) {
      let sellP =
        isrepaired == REPAIR_TYPE.REPAIRED.code
          ? homeData?.repaired && homeData?.square
            ? formatMultiplies([homeData?.repaired, homeData?.square], 2)
            : 0
          : homeData?.norepaired && homeData?.square
            ? formatMultiplies([homeData.norepaired, homeData?.square], 2)
            : 0;
      if (
        Number(homeData?.terassa) &&
        (Number(homeData?.terassa_price) ||
          Number(homeData?.terassa_price_repaired))
      ) {
        const terassaPrice =
          isrepaired == REPAIR_TYPE.REPAIRED.code
            ? Number(homeData?.terassa_price_repaired)
            : Number(homeData?.terassa_price);
        sellP += formatMultiplies([terassaPrice, homeData?.terassa], 2);
      }
      if (homeData?.isvalute != currency) {
        if (currency == CURRENCY_TYPE.VALUTE.code) {
          sellP = sellP / currencyData.sum;
        } else {
          sellP = sellP * currencyData.sum;
        }
      }

      if (homeData?.issquareprice == '0') {
        sellP = homeData?.totalsum;
      }

      setFullPrice(sellP);
      setSellPrice(sellP);
      setMonth(homeData?.blocks?.month || month);
      // setIsrepaired(isrepaired || month);
      setDiscount(0);
      setDiscountPercentage(0);
      setPriceForMonth(
        formatSingle(
          (sellP - formatSingle((sellP * +homeData?.start) / 100, 2)) /
            (homeData?.blocks?.month || month),
        ),
      );
      setStartPrice(formatSingle((sellP * +homeData?.start) / 100, 2));
      setStartPricePercentage(homeData?.start);
      setPriceForSquare(
        toCurrentCurrency(
          isrepaired == REPAIR_TYPE.REPAIRED.code
            ? homeData?.repaired
            : homeData?.norepaired,
        ),
      );
      setTerassaPriceForSquare(terassaUnitPrice());
    }
  }, [applyDiscount, isrepaired, isrepaired]);

  // Ipoteka limiti HAR DOIM amal qiladi — 700 mln kabi katta summani yagona
  // stavkada olib bo'lmaydi: limitgacha (masalan 480 mln) berilgan birlamchi
  // stavkada, undan oshgan qismi (220 mln) ikkilamchi kredit stavkasida
  // ALOHIDA hisoblanadi, so'ng ikkalasi bir oyga qo'shiladi (jami).
  // primaryRate — kr- uchun admin kiritgan foiz, sb- uchun MB/subsidiya stavkasi.
  const computeCreditSplit = (primaryRate) => {
    const creditNeeded = sellPrice - startPrice;
    const month = Number(creditMonths) || 240;
    const limit = Number(currencyData?.mortgage_limit) || 0;
    const secondaryRateConfigured = secondaryPercent;

    const isSplit = limit > 0 && creditNeeded > limit;
    const portion1Amount = isSplit ? limit : creditNeeded;
    const portion2Amount = isSplit ? creditNeeded - limit : 0;
    const secondaryRateMissing = isSplit && secondaryRateConfigured <= 0;
    const portion2Rate = secondaryRateMissing ? primaryRate : secondaryRateConfigured;

    const monthlyOf = (amount, rate) => {
      if (amount <= 0) return 0;
      const monthlyRate = rate / 100 / 12;
      const annuityFactor =
        (monthlyRate * Math.pow(1 + monthlyRate, month)) /
        (Math.pow(1 + monthlyRate, month) - 1);
      return amount * annuityFactor * (currency == 1 ? currencyData?.sum : 1);
    };

    const portion1Monthly = monthlyOf(portion1Amount, primaryRate);
    const portion2Monthly =
      portion2Amount > 0 ? monthlyOf(portion2Amount, portion2Rate) : 0;
    const combinedMonthly = portion1Monthly + portion2Monthly;

    return {
      isSplit,
      creditNeeded,
      limit,
      secondaryRateMissing,
      portion1: {
        amount: portion1Amount,
        rate: primaryRate,
        monthly: portion1Monthly,
        total: portion1Monthly * month,
      },
      portion2:
        portion2Amount > 0
          ? {
              amount: portion2Amount,
              rate: portion2Rate,
              monthly: portion2Monthly,
              total: portion2Monthly * month,
            }
          : null,
      combinedMonthly,
      combinedTotal: combinedMonthly * month,
    };
  };

  // "kr-" — admin kiritgan foiz (percent) birlamchi stavka sifatida, limitdan
  // oshgan qism esa ikkilamchi kredit stavkasida
  const calculations = useMemo(() => {
    const r = computeCreditSplit(percent);
    return {
      totalPayment: r.combinedTotal.toFixed(2),
      monthlyPayment: r.combinedMonthly.toFixed(2),
    };
  }, [
    sellPrice,
    startPrice,
    percent,
    currency,
    currencyData?.sum,
    currencyData?.mortgage_limit,
    secondaryPercent,
    creditMonths,
  ]);

  // "sb-" — MB/subsidiya stavkasi birlamchi (limitgacha) qismga, limitdan
  // oshgan qism baribir ikkilamchi kredit stavkasida (subsidiya faqat
  // limitgacha amal qiladi)
  const subsidyCals = useMemo(() => {
    // Subsidiyada mijoz stavkasi = MB asosiy stavkasining o'zi (admin kiritadi);
    // stavka kiritilmagan bo'lsa eski usul (kredit foizi − 4) saqlanadi
    const bankRate = Number(currencyData?.bank_rate);
    const subsidyPercent = bankRate > 0 ? bankRate : percent - 4;
    const r = computeCreditSplit(subsidyPercent);
    return {
      totalPayment: r.combinedTotal.toFixed(2),
      monthlyPayment: r.combinedMonthly.toFixed(2),
    };
  }, [
    sellPrice,
    startPrice,
    percent,
    currency,
    currencyData?.sum,
    currencyData?.bank_rate,
    currencyData?.mortgage_limit,
    secondaryPercent,
    creditMonths,
  ]);

  // "kr-/sb-" katakchasi bosilganda batafsil taqsimot shu yerdan olinadi —
  // "kr-" bilan bir xil formula (primaryRate = percent), shuning uchun
  // modaldagi "Jami oylik to'lov" har doim kr- bilan bir xil chiqadi.
  const splitCals = useMemo(
    () => computeCreditSplit(percent),
    [
      sellPrice,
      startPrice,
      percent,
      currency,
      currencyData?.sum,
      currencyData?.mortgage_limit,
      secondaryPercent,
      creditMonths,
    ],
  );

  useEffect(() => {
    const terassasum =
      Number(homeData?.terassa) && terassaPriceForSquare
        ? formatMultiplies([homeData?.terassa, terassaPriceForSquare], 2)
        : 0;

    setData({
      isvalute: currency,
      fullPrice,
      sellPrice,
      startPrice,
      startPricePercentage,
      month: month == 1 ? 0 : month,
      isrepaired,
      priceForMonth,
      priceForSquare,
      terassasum,
      discount,
      discountPercentage,
      lastPayment,
      calculations,
      subsidyCals,
    });
  }, [
    order,
    currency,
    fullPrice,
    sellPrice,
    startPrice,
    startPricePercentage,
    month,
    priceForMonth,
    priceForSquare,
    discount,
    isrepaired,
    discountPercentage,
    lastPayment,
    calculations,
    subsidyCals,
  ]);

  const handleChange = (e) => {
    setIsrepaired(e?.target?.value);
  };

  useEffect(() => {
    if (startPricePercentage == 100) {
      setMonth(1);
      // 100% boshlang'ich to'lov = to'liq SOTUV summasi ("Chegirmadan oldin"
      // yoqilgan bo'lsa — umumiy summa). Sotuv summasi keyinroq o'zgarsa
      // (chegirma qo'llanishi, m² narxi tahriri, valyuta almashuvi) ham
      // boshlang'ich to'lov unga ergashadi — oldin eski qiymatda qolib,
      // umumiy summa ko'rinib qolardi.
      const base = startPriceTopOrder ? fullPrice : sellPrice;
      if (base && startPrice !== base) {
        setStartPrice(base);
        setPriceForMonth(0);
      }
    } else if (!month) {
      // setMonth(homeData?.blocks.month || 24);
      // setPriceForMonth(
      //   formatSingle(
      //     ((startPriceTopOrder ? fullPrice : sellPrice) - startPrice) /
      //       parseInt(homeData?.blocks.month || 24)
      //   )
      // );
      setPriceForMonth(0);
    }
  }, [
    startPricePercentage,
    homeData?.blocks?.month,
    sellPrice,
    startPrice,
    month,
    startPriceTopOrder,
    fullPrice,
  ]);

  useEffect(() => {
    if (!applyDiscount && formik.values.discountId) {
      setApplyDiscount(true);
    }
  }, [formik.values.discountId]);

  const handleChangeLastPayment = (payment) => {
    setLastPayment(payment);
    const priceForMonth = (sellPrice - startPrice - payment) / month;
    setPriceForMonth(+priceForMonth?.toFixed(2));
    setLastPaymentPercentage((payment / sellPrice) * 100);
  };
  const handleChangePriceForMonth = (payment) => {
    setPriceForMonth(payment);
    const lastPayment = sellPrice - startPrice - payment * month;
    setLastPayment(+lastPayment?.toFixed(2));
    setLastPaymentPercentage((lastPayment / sellPrice) * 100);
  };
  const handleChangeLastPaymentPercentage = (percent) => {
    const pr = percent || 0;
    setLastPaymentPercentage(pr);
    const priceForMonth =
      (sellPrice - startPrice - (sellPrice * pr) / 100) / month;
    setPriceForMonth(+priceForMonth?.toFixed(2));
    setLastPayment((sellPrice * pr) / 100);
  };

  return (
    <div className='calculation-wrapper !border-none !p-0'>
      <div>
        <div className='home-details-header !items-center fixed right-36 top-2'>
          {/* {t('shaxmatka.moreHomeDetails.selectedHomes')} */}
          {/* <div className='currency-data'>
            {currency == CURRENCY_TYPE.VALUTE.code && (
              <div className='mr-2 whitespace-nowrap'>
                {t('common.fields.currency')}:{' '}
                <NumericFormat
                  value={currencyData?.sum}
                  allowNegative={false}
                  displayType={'text'}
                  thousandSeparator={' '}
                  decimalScale={1}
                  className='w-full text-right'
                  suffix=' UZS'
                />
              </div>
            )}
            <SimpleToggleButtonGroup
              delay={0}
              duration={0}
              value={currency?.toString()}
              changeFn={handleCurrencyTypeChange}
              options={currencyTypeSelectOptions}
              size='small'
              fullWidth={true}
              buttonClassName='whitespace-nowrap'
            />
          </div> */}
        </div>
      </div>
      {designType == 'old' ? (
        <OldDesign
          homesData={homesData}
          selectedDiscount={selectedDiscount}
          priceForSquare={priceForSquare}
          terassaPriceForSquare={terassaPriceForSquare}
          handleChangePriceSquare={handleChangePriceSquare}
          handleChangeTerassaPriceSquare={handleChangeTerassaPriceSquare}
          currency={currency}
          sellPrice={sellPrice}
          handleChangeSellPrice={handleChangeSellPrice}
          isrepaired={isrepaired}
          handleChange={handleChange}
          discount={discount}
          discountPercentage={discountPercentage}
          homeData={homeData}
          startPriceTopOrder={startPriceTopOrder}
          handleChangeStartPriceOrder={handleChangeStartPriceOrder}
          startPricePercentage={startPricePercentage}
          handleChangeStartPricePercent={handleChangeStartPricePercent}
          startPrice={startPrice}
          handleChangeStartPrice={handleChangeStartPrice}
          month={month}
          handleChangeMonth={handleChangeMonth}
          setApplyDiscount={setApplyDiscount}
          applyDiscount={applyDiscount}
          formik={formik}
          fullPrice={fullPrice}
          handleChangeDiscount={handleChangeDiscount}
          handleChangeDiscountPercentage={handleChangeDiscountPercentage}
          priceForMonth={priceForMonth}
          isEnableCalc={isEnableCalc}
          setIsEnableCalc={setIsEnableCalc}
          percent={percent}
          setPercent={setPercent}
          calculations={calculations}
          subsidyCals={subsidyCals}
          splitCals={splitCals}
          secondaryPercent={secondaryPercent}
          setSecondaryPercentOverride={setSecondaryPercentOverride}
          creditMonths={creditMonths}
          setCreditMonths={setCreditMonths}
          setStartPrice={setStartPrice}
          setStartPricePercentage={setStartPricePercentage}
          setDiscount={setDiscount}
          setDiscountPercentage={setDiscountPercentage}
          setSellPrice={setSellPrice}
          setPriceForMonth={setPriceForMonth}
          setMonth={setMonth}
          setPriceForSquare={setPriceForSquare}
          setTerassaPriceForSquare={setTerassaPriceForSquare}
          setSelectedDiscount={setSelectedDiscount}
          setStartPriceTopOrder={setStartPriceTopOrder}
          lastPayment={lastPayment}
          handleChangeLastPayment={handleChangeLastPayment}
          lastPaymentPercentage={lastPaymentPercentage}
          handleChangeLastPaymentPercentage={handleChangeLastPaymentPercentage}
          isCreditTable={isCreditTable}
          isSubsidy={isSubsidy}
          handleChangePriceForMonth={handleChangePriceForMonth}
        />
      ) : (
        <NewDesign
          homesData={homesData}
          selectedDiscount={selectedDiscount}
          priceForSquare={priceForSquare}
          terassaPriceForSquare={terassaPriceForSquare}
          handleChangePriceSquare={handleChangePriceSquare}
          handleChangeTerassaPriceSquare={handleChangeTerassaPriceSquare}
          currency={currency}
          sellPrice={sellPrice}
          handleChangeSellPrice={handleChangeSellPrice}
          isrepaired={isrepaired}
          handleChange={handleChange}
          discount={discount}
          discountPercentage={discountPercentage}
          homeData={homeData}
          startPriceTopOrder={startPriceTopOrder}
          handleChangeStartPriceOrder={handleChangeStartPriceOrder}
          startPricePercentage={startPricePercentage}
          handleChangeStartPricePercent={handleChangeStartPricePercent}
          startPrice={startPrice}
          handleChangeStartPrice={handleChangeStartPrice}
          month={month}
          handleChangeMonth={handleChangeMonth}
          setApplyDiscount={setApplyDiscount}
          applyDiscount={applyDiscount}
          formik={formik}
          fullPrice={fullPrice}
          handleChangeDiscount={handleChangeDiscount}
          handleChangeDiscountPercentage={handleChangeDiscountPercentage}
          priceForMonth={priceForMonth}
          isEnableCalc={isEnableCalc}
          setIsEnableCalc={setIsEnableCalc}
          percent={percent}
          setPercent={setPercent}
          calculations={calculations}
          subsidyCals={subsidyCals}
          setStartPrice={setStartPrice}
          setStartPricePercentage={setStartPricePercentage}
          setDiscount={setDiscount}
          setDiscountPercentage={setDiscountPercentage}
          setSellPrice={setSellPrice}
          setPriceForMonth={setPriceForMonth}
          setMonth={setMonth}
          setPriceForSquare={setPriceForSquare}
          setTerassaPriceForSquare={setTerassaPriceForSquare}
          setSelectedDiscount={setSelectedDiscount}
          setStartPriceTopOrder={setStartPriceTopOrder}
          filters={filters}
          setFilters={setFilters}
          lastPayment={lastPayment}
          handleChangeLastPayment={handleChangeLastPayment}
          lastPaymentPercentage={lastPaymentPercentage}
          handleChangeLastPaymentPercentage={handleChangeLastPaymentPercentage}
          isCreditTable={isCreditTable}
          isSubsidy={isSubsidy}
          handleChangePriceForMonth={handleChangePriceForMonth}
        />
      )}
    </div>
  );
};
export default memo(CalculationByHomeData);
